import Blockie from "./Blockie";
import LinkWithSearchParams from "./LinkWithSearchParams";

const ProfileBadge = ({ profile }) => {
    return (
        <LinkWithSearchParams
            className="hover:opacity-70"
            to={{
                pathname: `/profile/${profile?.username}`,
            }}
        >
            {profile?.avatarLink ? (
                <img
                    className="rounded-full ring-4 ring-kadComponentBg profile-badge-avatar"
                    src={profile?.avatarLink}
                    alt="profile avatar"
                />
            ) : (
                <Blockie
                    address={profile?.wallet}
                    className="rounded-full ring-4 ring-kadComponentBg"
                    scale={5}
                />
            )}
        </LinkWithSearchParams>
    );
};

export default ProfileBadge;
